import { TUser } from './types'

export function isAdminUser(user: TUser) {
  return ['super', 'admin'].includes(user?.type?.toLowerCase())
}
